var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketingOfficeOrganizationSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dbe9fa;}.cls-2{fill:#d9dce1;}.cls-3{fill:#52acf9;}.cls-4{fill:#ffffff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "organization"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "17 15 17 8 15 8 15 15 5 15 5 24 7 24 7 17 15 17 15 24 17 24 17 17 25 17 25 24 27 24 27 15 17 15"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    height: 8,
    width: 8,
    x: 12,
    y: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    height: 8,
    width: 8,
    x: 12,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    height: 8,
    width: 8,
    x: 22,
    y: 22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    height: 8,
    width: 8,
    x: 2,
    y: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,22V15H17V10h3V2H12v8h3v5H5v7H2v8h8V22H7V17h8v5H12v8h8V22H17V17h8v5H22v8h8V22ZM14,8V4h4V8H14ZM8,24v4H4V24H8Zm10,0v4H14V24h4Zm10,4H24V24h4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingOfficeOrganizationSvgrepoCom);
export default __webpack_public_path__ + "static/media/marketing-office-organization-svgrepo-com.fe7bce0d4c6ad7a7b4bd5a0938a70ef1.svg";
export { ForwardRef as ReactComponent };